import * as React from 'react';
import '../css/billboard.sass';
import style2object from '../utils/style-object';
import ActionButtons, { ActionButton } from './ActionButtons';

interface BillBoardProps {
  title: string;
  message: React.ReactNode;
  description: React.ReactNode;
  buttons?: ActionButton[];
  theme?: 'night' | 'day';
  style?: string;
  type?: 'full' | 'half';
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4';
  className?: string;
}

export default function BillBoard(props: BillBoardProps) {
  const { theme = 'day', type = 'half', headingLevel = 'h1' } = props;

  const customStyle = props.style ? style2object(props.style) : {};

  const HeadingTag: React.ElementType = headingLevel;
  const headingClassName = props.className ? props.className : '';

  return (
    <div className={`billboard ${theme}`} style={customStyle}>
      <HeadingTag
        className={headingLevel === 'h1' ? 'title' : headingClassName}
      >
        {props.title}
      </HeadingTag>
      <span className={`secondarySection ${type}`}>
        <div className="subhead">{props.message}</div>
        <div className="section-description">{props.description}</div>
      </span>
      {props.buttons && <ActionButtons buttons={props.buttons} />}
    </div>
  );
}
